import { render, staticRenderFns } from "./sportcalendar.vue?vue&type=template&id=22e6ed93"
import script from "./sportcalendar.vue?vue&type=script&lang=js"
export * from "./sportcalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports